import { Query } from "components/common"
import { FETCH_DIRECTOR } from "lib/graphql"

export default ({id, children, renderLoading}) => (
	<Query query={FETCH_DIRECTOR} options={{variables: { id }}} renderLoading={renderLoading}>
		{({cms: { directors: { items: directors } }}) => children(directors[0]) }
	</Query>
)
